import React from 'react';
import { SKY_BROADBAND_T_AND_C_URL, TERMS_AND_CONDITIONS_DOMESTIC, SKY_TV_T_AND_C_URL } from '../config';
import { JSONConfigService, links, useJSONConfig } from '@sky-tv-group/shared';
import DOMPurify from 'dompurify';

interface TermsAndConditionsProps {
  isActiveSkyStarter: boolean;
  containerClassName?: string;
  fontClass?: string;
  configService: JSONConfigService;
}

const BroadbandTerms = ({
  isActiveSkyStarter,
  containerClassName,
  fontClass,
  configService,
}: TermsAndConditionsProps) => {
  const config = useJSONConfig(configService);
  const mbnzSpeedDisclaimer = config?.broadband?.acquisition?.mbnzSpeedDisclaimer?.desc;
  return (
    <>
      <div className={containerClassName}>
        <p
          className={fontClass}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(mbnzSpeedDisclaimer || ''),
          }}></p>
      </div>
      {isActiveSkyStarter ? (
        <div className={'m-auto flex flex-col items-center justify-center pt-4' + fontClass}>
          <div className="pb-2">
            Sky Broadband on a <strong>rolling monthly plan</strong>.
          </div>
          <div>
            <a href={TERMS_AND_CONDITIONS_DOMESTIC} className="text-primary-day-light underline">
              Consumer Terms
            </a>
            ,{' '}
            <a href={SKY_BROADBAND_T_AND_C_URL} className="text-primary-day-light underline">
              Broadband Terms
            </a>{' '}
            and{' '}
            <a href={links.bbExitFees} className="text-primary-day-light underline">
              Exit Fees
            </a>{' '}
            apply to all plans.
          </div>
        </div>
      ) : (
        <div className={'m-auto flex flex-col items-center justify-center pt-4' + fontClass}>
          <p style={{ textIndent: '1.5rem' }} className="pb-2">
            Join Sky TV on a <strong>12 month contract</strong> and get Sky Broadband on{' '}
            <strong>a rolling monthly plan</strong>. Only want Sky Broadband? Plans available on a{' '}
            <strong>12 month contract</strong>.
          </p>
          <div className="pb-2">
            See{' '}
            <a href={SKY_TV_T_AND_C_URL} className="text-primary-day-light underline">
              Sky TV Offer T&amp;Cs
            </a>{' '}
          </div>
          <div>
            <a href={TERMS_AND_CONDITIONS_DOMESTIC} className="text-primary-day-light underline">
              Consumer Terms
            </a>
            ,{' '}
            <a href={SKY_BROADBAND_T_AND_C_URL} className="text-primary-day-light underline">
              Broadband Terms
            </a>{' '}
            and{' '}
            <a href={links.bbExitFees} className="text-primary-day-light underline">
              Exit Fees
            </a>{' '}
            apply to all plans.
          </div>
        </div>
      )}
    </>
  );
};

export { BroadbandTerms };
